<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn v-if="page.isNew" id="btnSave" type="submit" elevation="0" color="primary" dark
                            :loading="loading" @click="add">Salvar</v-btn>
                        <v-btn v-else id="btnSave" type="submit" elevation="0" color="primary" dark :loading="loading"
                            @click="update">Salvar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" outlined color="primary"
                            @click="goBack">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="form-card">
                    <v-card-text>
                        <v-form ref="form" @submit.prevent="save">
                            <v-row>
                                <v-col cols-10>
                                    <v-text-field dense outlined v-model="dataset.data.name" label="Nome" step="any"
                                        :rules="[$rules.required]" required hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-currency-field label="Valor" dense v-model="dataset.data.value" prefix="R$"
                                        :allowNegative=false hide-details="auto" outlined>
                                    </v-currency-field>
                                </v-col>
                            </v-row>

                            <v-subheader class="pl-0 font-weight-bold">Origem</v-subheader>
                            <v-row>
                                <v-col cols="12">
                                    <v-autocomplete dense outlined :items="dataset.addresses.origin"
                                        label="Endereço de Embarque" :loading="dataset.loading.origin"
                                        v-model="dataset.data.origin_address" :search-input.sync="searchAddress.origin"
                                        @update:search-input="val => getAddressByType('origin', val)" item-value="id"
                                        item-text="address" return-object hide-details="auto" clearable
                                        :rules="[$rules.required]"
                                        @change="onAddressSelected('origin', $event)"></v-autocomplete>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field dense outlined v-model="dataset.data.origin_latitude" label="Latitude"
                                        type="number" step="any" :rules="[$rules.required]" required
                                        hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field dense outlined v-model="dataset.data.origin_longitude"
                                        label="Longitude" type="number" step="any" :rules="[$rules.required]" required
                                        hide-details="auto"></v-text-field>
                                </v-col>
                            </v-row>

                            <v-subheader class="pl-0 font-weight-bold">Destino</v-subheader>
                            <v-row>
                                <v-col cols="12">
                                    <v-autocomplete dense outlined :items="dataset.addresses.destination"
                                        label="Endereço de destino" :loading="dataset.loading.destination"
                                        v-model="dataset.data.destination_address"
                                        :search-input.sync="searchAddress.destination"
                                        @update:search-input="val => getAddressByType('destination', val)"
                                        item-value="id" item-text="address" return-object hide-details="auto" clearable
                                        :rules="[$rules.required]"
                                        @change="onAddressSelected('destination', $event)"></v-autocomplete>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field dense outlined v-model.number="dataset.data.destination_latitude"
                                        label="Latitude" type="number" step="any" :rules="[$rules.required]" required
                                        hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field dense outlined v-model.number="dataset.data.destination_longitude"
                                        label="Longitude" type="number" step="any" :rules="[$rules.required]" required
                                        hide-details="auto"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';
import string from "@/common/util/string";

import debounce from 'lodash/debounce'

export default {
    name: 'ItineraryDetails',
    data: () => ({
        dataset: {
            data: {},
            loading: {
                origin: false,
                destination: false
            },
            addresses: {
                origin: [],
                destination: []
            },
        },
        page: {
            title: "",
            isNew: false
        },
        loading: false,
        searchAddress: {
            origin: '',
            destination: ''
        },

        searchLocation: '',

        abortControllers: {
            origin: null,
            destination: null
        },
        sessionTokens: {
            origin: null,
            destination: null
        },
    }),

    computed: {
        breadcrumbItems() {
            const items = [
                { text: 'Home', disabled: false, to: '/home', exact: true },
                { text: 'Itinerários', disabled: false, to: '/itinerarios', exact: true },
            ];

            items.push({
                text: !this.page.isNew ? 'Editar' : 'Novo',
                disabled: true,
                exact: true,
            });
            return items;
        },
    },

    watch: {
        searchLocation(val) {
            this.loadLocations(val);
        },

        searchAddress(val) {
            this.getAddressByName(val);
        },
    },

    created() {
        this.setPage();
        this.load();
    },

    methods: {
        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = this.page.isNew ? "Novo itinerário" : "Detalhes do itinerário";
        },

        async load() {
            if (this.page.isNew) return;

            this.loading = true;
            try {
                const response = await axios.get(`/api/v2/itineraries/${this.$route.params.id}`);

                this.dataset.data = response.data.content

                this.dataset.addresses.origin = [{ iid: this.dataset.data.origin_iid, address: this.dataset.data.origin_address }]
                this.dataset.addresses.destination = [{ iid: this.dataset.data.destination_iid, address: this.dataset.data.destination_address }]
            } catch (error) {
                console.error('Erro ao carregar detalhes do itinerário:', error.response || error);
                this.$dialog.notify.error(this.$codes(error) || 'Erro ao carregar detalhes do itinerário.', { position: 'top-right', timeout: 5000 });
                this.goBack();
            } finally {
                this.loading = false;
            }
        },

        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja salvar o itinerário?',
                title: 'Itinerário',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                await axios.post(`/api/v2/itineraries`, payload, { config: { headers: { "Content-Type": "application/json" } } });

                this.$dialog.notify.info("Itinerário salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar o itinerário?',
                title: 'Itinerário',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                await axios.patch(`/api/v2/itineraries/${this.$route.params.id}`, payload, { config: { headers: { "Content-Type": "application/json" } } });

                this.$dialog.notify.info("Itinerário salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        loadLocations: debounce(async function (filter) {

            this.dataset.locationLoading = true;

            console.log("nome busca filtro: ", filter)

            let search = filter ? { name: filter } : {}

            try {
                const result = await axios.get(`/api/v2/locations`, { params: { start: 1, limit: 10, search } });

                this.dataset.locations = result.data.data

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.locationLoading = false;
            }
        }, 1000),

        getAddressByType: debounce(async function (type, name) {
            if (!name || name.trim().length < 3) {
                this.dataset.addresses[type] = [];
                this.sessionTokens[type] = null;
                return;
            }

            if (!this.sessionTokens[type]) {
                this.sessionTokens[type] = (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : `${Date.now()}${Math.random()}`;
            }

            if (this.abortControllers[type]) {
                this.abortControllers[type].abort();
            }

            this.abortControllers[type] = new AbortController();
            this.dataset.loading[type] = true;

            try {
                const response = await axios.get(`/api/v2/google-maps/find/${encodeURIComponent(name)}`, {
                    params: { sessiontoken: this.sessionTokens[type] },
                    signal: this.abortControllers[type].signal
                });

                this.dataset.addresses[type] = response.data.content.map(x => ({
                    address: x.address,
                    iid: x.placeId
                }));
            } catch (error) {
                if (!axios.isCancel(error)) {
                    console.error(`Erro ao buscar endereço (${type}):`, error);
                }
            } finally {
                this.dataset.loading[type] = false;
            }
        }, 500),

        async onAddressSelected(type, addressObj) {
            const location = await this.getCoordsFromPlaceId(addressObj.iid, type);
            if (location) {
                this.dataset.data[`${type}_address`] = addressObj.address;
                this.dataset.data[`${type}_iid`] = addressObj.iid;
                this.dataset.data[`${type}_latitude`] = location.lat;
                this.dataset.data[`${type}_longitude`] = location.lng;
                this.dataset.data[`${type}_city`] = location.city;
                this.dataset.data[`${type}_state`] = location.state;
                this.sessionTokens[type] = null;
            }
        },

        async getCoordsFromPlaceId(placeId, type = null) {
            try {
                const response = await axios.get(`/api/v2/google-maps/place-details/${placeId}`, {
                    params: type && this.sessionTokens[type] ? { sessiontoken: this.sessionTokens[type] } : {}
                });

                const { coordinates, city, state } = response.data.content;

                return {
                    lat: coordinates.lat,
                    lng: coordinates.lng,
                    city,
                    state
                };
            } catch (error) {
                console.error('Erro ao buscar coordenadas:', error);
                return null;
            }
        },

        buildPayload() {
            const data = {
                name: this.dataset.data.name,
                origin_address: this.dataset.data.origin_address,
                origin_iid: this.dataset.data.origin_iid,
                origin_latitude: this.dataset.data.origin_latitude,
                origin_longitude: this.dataset.data.origin_longitude,
                origin_city: this.dataset.data.origin_city,
                origin_state: this.dataset.data.origin_state,
                destination_address: this.dataset.data.destination_address,
                destination_iid: this.dataset.data.destination_iid,
                destination_latitude: this.dataset.data.destination_latitude,
                destination_longitude: this.dataset.data.destination_longitude,
                destination_city: this.dataset.data.destination_city,
                destination_state: this.dataset.data.destination_state,
                value: this.dataset.data.value
            }

            return data;
        },

        goBack() {
            this.$router.push('/itinerarios');
        },
    },
};
</script>
